import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";

export function SortableHeader({ label, sortKey, currentSort, currentDir, onSort, className = "" }) {
  const isActive = currentSort === sortKey;
  
  const handleClick = () => {
    if (isActive) {
      onSort(sortKey, currentDir === "asc" ? "desc" : "asc");
    } else {
      onSort(sortKey, "asc");
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center gap-1 hover:text-primary transition-colors font-semibold text-left ${className}`}
      data-testid={`sort-${sortKey}`}
    >
      {label}
      {isActive ? (
        currentDir === "asc" ? (
          <ArrowUp className="h-3.5 w-3.5 text-primary" />
        ) : (
          <ArrowDown className="h-3.5 w-3.5 text-primary" />
        )
      ) : (
        <ArrowUpDown className="h-3.5 w-3.5 opacity-30" />
      )}
    </button>
  );
}

export function sortData(data, sortKey, sortDir) {
  if (!sortKey || !data?.length) return data;
  
  return [...data].sort((a, b) => {
    let valA = a[sortKey];
    let valB = b[sortKey];

    // v3.10: per i clienti con nome e cognome separati, la colonna "Nome" ordina
    // per COGNOME (le altre pagine, che non hanno questi campi, non cambiano).
    if (sortKey === "name" && (a.last_name || b.last_name)) {
      valA = `${a.last_name || valA || ""} ${a.first_name || ""}`.trim();
      valB = `${b.last_name || valB || ""} ${b.first_name || ""}`.trim();
    }
    
    // Handle nulls
    if (valA == null) valA = "";
    if (valB == null) valB = "";
    
    // Numeric comparison
    if (typeof valA === "number" && typeof valB === "number") {
      return sortDir === "asc" ? valA - valB : valB - valA;
    }
    
    // String comparison
    const strA = String(valA).toLowerCase();
    const strB = String(valB).toLowerCase();
    
    // Try date comparison (YYYY-MM-DD)
    if (/^\d{4}-\d{2}-\d{2}/.test(strA) && /^\d{4}-\d{2}-\d{2}/.test(strB)) {
      return sortDir === "asc" ? strA.localeCompare(strB) : strB.localeCompare(strA);
    }
    
    return sortDir === "asc" ? strA.localeCompare(strB) : strB.localeCompare(strA);
  });
}
